<template>
  <div class="foot-path">
    <!-- 头部导航组件 -->
    <header-cmp ref="headerEle"></header-cmp>
    <menu-cmp ref="menuEle"></menu-cmp>
    <section class="fp-page">
      <div class="banner map">
        <div class="search-panel">
          <div class="map-search-panel">
            <div class="map-search-panel-h">
              <el-cascader class="map-search-cascader" size="large" :options="regionData"
                :props="{ checkStrictly: true, value: 'label' }" placeholder="请选择省市区" :value="searchArea" clearable
                @change="handleSearchAreaChange" ref="searchCascader">
              </el-cascader>
              <el-input class="map-search-input" v-model="searchString" placeholder="场地/步道名称" clearable>
                <i slot="suffix" class="el-icon-search" @click.prevent.stop="
                  getAlamedaList();
                showSearchRes = true;
                " />
              </el-input>
            </div>
            <el-tabs v-model="mapSearchActive" @tab-click="handleTabClick" :class="`map-search-res ${showSearchRes ? '' : 'map-search-res-mo-hide'
              }`" :stretch="true">
              <el-tab-pane label="步道" name="1">
                <ul class="alameda-ul scrollview" ref="scrollview" v-searchresult-scroll="handleResultScroll">
                  <template v-if="alamedaList1.length">
                    <li v-for="item in alamedaList1" :key="'r' + item.id" class="alameda-li" style=""
                      @click="showMapWindow(item)">
                      <div class="alameda-li-left">
                        <div class="alameda-li-name" :class="{ 'alameda-item-name-wlogo': item.type == 1 }">{{ item.name
                        }}
                        </div>
                        <template v-if="item.type == 1">
                          <img :src="require('@/assets/image/fp/map-star' +
                            (i > item.rank ? '' : '-fill') +
                            '.png')
                            " class="map-info-window-star" v-for="i in 5" :key="'star1' + i" />
                        </template>
                      </div>
                      <img class="alameda-li-img" v-if="item.imgs && item.imgs.length" v-lazy-load="item.imgs[0]" />
                    </li>
                  </template>
                  <div class="no-data" v-else>暂无数据</div>
                </ul>
              </el-tab-pane>
              <el-tab-pane label="场地" name="0">
                <ul class="alameda-ul scrollview" ref="scrollview" v-searchresult-scroll="handleResultScroll">
                  <template v-if="alamedaList0.length">
                    <li v-for="item in alamedaList0" :key="'li' + item.id" class="alameda-li"
                      @click="showMapWindow(item)">
                      <div class="alameda-li-left">
                        <div class="alameda-li-name">{{ item.name }}</div>
                        <span class="alameda-li-type" v-if="item.certsn">{{
                          getSiteCategoryText(item)
                        }}</span>
                      </div>
                      <img class="alameda-li-img" v-if="item.imgs && item.imgs.length" :src="item.imgs[0]" />
                    </li>
                  </template>
                  <div class="no-data" v-else>暂无数据</div>
                </ul>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="map-info-window">
            <div class="map-info-window-body">
              <div class="map-info-window-body-left">
                <h5 class="map-info-window-title" :class="{ 'alameda-item-name-wlogo': infoWindow.type == 1 }">
                  {{ infoWindow.name }}
                </h5>
                <div v-if="infoWindow.type == 1" class="map-info-window-tip"
                  :class="{ 'map-info-window-tip-un': infoWindow.type != 1 }">
                  中国田径协会审定步道
                </div>
                <div class="map-info-window-tags">
                  <div class="map-info-window-tag" v-if="infoWindow.smart">
                    智慧步道
                  </div>
                  <span class="alameda-li-type" v-if="mapSearchActive == 0 && infoWindow.certsn">{{
                    getSiteCategoryText(infoWindow)
                  }}</span>
                  <template v-else-if="infoWindow.type == 1">
                    <span :class="`el-icon-star-${i > infoWindow.rank ? 'off' : 'on'
                      } map-info-window-star`" v-for="i in 5" :key="'star' + i"></span>
                  </template>
                </div>
                <div class="map-info-window-address" v-if="infoWindow.address">
                  地址：{{ infoWindow.address }}
                </div>
              </div>
              <div v-if="infoWindow.imgs && infoWindow.imgs.length" class="map-info-window-img"
                :style="{ backgroundImage: 'url(' + infoWindow.imgs[0] + ')' }"></div>
            </div>
            <el-divider />

            <ul>
              <template v-for="item in detailList[infoWindow.type == 0 ? 0 : 1]">
                <li v-if="getInfoWndText(item)" class="a-detail-dialog-li" :key="'d' + item.id">
                  {{ item.title }}：{{ getInfoWndText(item) }}{{ item.unit }}
                </li>
              </template>
            </ul>
          </div>
        </div>
        <!-- <baidu-map class="bmView" ref="bmViewRef" :scroll-wheel-zoom="true" :center="center" :zoom="zoom"
          @ready="mapHandler" :ak="myMapKey" :mapClick="false">
     

          <bm-view style="width: 100%; height: 100%; flex: 1"></bm-view>
          <bm-info-window :position="infoWindow.point" :show="infoWindow.showFlag" v-if="infoWindow">
            <div class="map-info-window">
              <div class="map-info-window-body">
                <div class="map-info-window-body-left">
                  <h5 class="map-info-window-title" :class="{ 'alameda-item-name-wlogo': infoWindow.type == 1 }">
                    {{ infoWindow.name }}
                  </h5>
                  <div v-if="infoWindow.type == 1" class="map-info-window-tip"
                    :class="{ 'map-info-window-tip-un': infoWindow.type != 1 }">
                    中国田径协会审定步道
                  </div>
                  <div class="map-info-window-tags">
                    <div class="map-info-window-tag" v-if="infoWindow.smart">
                      智慧步道
                    </div>
                    <span class="alameda-li-type" v-if="mapSearchActive == 0 && infoWindow.certsn">{{
                      getSiteCategoryText(infoWindow)
                    }}</span>
                    <template v-else-if="infoWindow.type == 1">
                      <span :class="`el-icon-star-${i > infoWindow.rank ? 'off' : 'on'
                        } map-info-window-star`" v-for="i in 5" :key="'star' + i"></span>
                    </template>
                  </div>
                  <div class="map-info-window-address" v-if="infoWindow.address">
                    地址：{{ infoWindow.address }}
                  </div>
                </div>
                <div v-if="infoWindow.imgs && infoWindow.imgs.length" class="map-info-window-img"
                  :style="{ backgroundImage: 'url(' + infoWindow.imgs[0] + ')' }"></div>
              </div>
              <el-divider />
              <div class="map-info-window-footer">
                <div @click="showDetailDialog()">查看更多</div>
                <div class="map-info-window-footer-navigation" @click.stop.prevent="wakeBaidu(infoWindow)">
                  导航
                </div>
              </div>
            </div>
          </bm-info-window>
          <div v-for="marker in alamedaListPoints" :key="marker.id">
            <bm-polyline v-if="marker.type != 0" :path="marker.points" stroke-color="red" :stroke-opacity="0.5"
              :stroke-weight="10"></bm-polyline>
            <bm-marker :position="marker.point" v-if="marker.point" @click="infoWindowOpen(marker)" :icon="{
              url: require('@/assets/image/fp/map-mark-' +
                marker.type +
                '.png'),
              size: { width: (marker.type == 1 ? 37 : 32), height: (marker.type == 1 ? 24 : 32) },
              opts: { imageSize: { width: (marker.type == 1 ? 37 : 32), height: (marker.type == 1 ? 24 : 32) } },
            }">
            </bm-marker>
          </div>
        </baidu-map> -->
      </div>

      <!--弹窗查看步道/场地信息-->
      <el-dialog :title="`${infoWindow.type == 0 ? '场地' : '步道'}信息`" :visible.sync="detailDialog" class="a-detail-dialog"
        v-if="infoWindow">
        <div slot="title">
          <span v-if="infoWindow.type == 1" class="a-detail-dialog-title-c">中国田径协会认证</span>
          {{ infoWindow.type == 0 ? "场地" : "步道" }}信息
        </div>
        <div class="a-detail-dialog-imgs" v-if="infoWindow.imgs && infoWindow.imgs.length">
          <img :src="img" v-for="img in infoWindow.imgs" :key="img" class="a-detail-dialog-img"
            @click="handlePictureCardPreview({ url: img })" />
        </div>
        <ul>
          <template v-for="item in detailList[infoWindow.type == 0 ? 0 : 1]">
            <li v-if="getInfoWndText(item)" class="a-detail-dialog-li" :key="'d' + item.id">
              {{ item.title }}：{{ getInfoWndText(item) }}{{ item.unit }}
            </li>
          </template>
        </ul>
      </el-dialog>
      <!--上传步道/场地信息-->
      <el-dialog :close-on-click-modal="false" title="上传步道信息" :visible.sync="uploadDialog"
        class="a-detail-dialog edit-dialog" @close="closeDialog">
        <el-form ref="alameformRef" :model="alameform" :rules="rules" label-position="left">
          <!-- <el-form-item label="上传类型：" prop="type">
            <el-select v-model="alameform.type" placeholder="请选择上传类型">
              <el-option label="场地" :value="0"></el-option>
              <el-option label="认证步道" :value="1"></el-option>
              <el-option label="非认证步道" :value="2"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="名称：" prop="name">
            <el-input v-model="alameform.name" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="省市区：" prop="region">
            <el-cascader size="large" :options="regionData" v-model="alameform.region" @change="handleRegionChange">
            </el-cascader>
          </el-form-item>
          <el-form-item label="详细地址：" prop="address">
            <el-input v-model="alameform.address" placeholder="请输入详细地址"></el-input>
          </el-form-item>
          <el-form-item label="步道图片：" prop="imgs"><!--:show-file-list="false"-->
            <el-upload class="edit-dialog-img-uploader" action="" :http-request="fnUploadRequest" list-type="picture-card"
              :limit="8" name="imgs" accept=".jpg,.jpeg,.png,.gif" :on-success="handleImgSuccess"
              :before-upload="beforeImgUpload" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
              ref="imgUploaderRef">
              <!-- <img v-if="alameform.imageUrl" :src="alameform.imageUrl" class="edit-dialog-img-uploader-img"> -->
              <img class="edit-dialog-img-uploader-icon" :src="require('@/assets/image/fp/icon_add.png')" />
              <div slot="tip" class="el-upload__tip">
                上传小于30MB的文件，支持png/jpg文件
              </div>
            </el-upload>
          </el-form-item>
          <!-- <el-form-item prop="points" label="地图标注：" style="margin-bottom: 0" :inline-message="true">
          </el-form-item>
          <div class="edit-dialog-map">
            <baidu-map class="edit-dialog-bm-view" :zoom="15" :center="editCenter" :ak="myMapKey" inertial-dragging
              @ready="editMapReady" @click="editSelectPoint" :mapClick="false">
              <bm-marker v-for="(item, index) in editPoints" :position="item" :dragging="false"
                :key="'point' + index"></bm-marker>
              <bm-polyline v-if="editPoints.length" :path="editPoints" stroke-color="red" :stroke-opacity="0.5"
                :stroke-weight="8" :editing="true" @lineupdate="updatePolylinePath"></bm-polyline>
              <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
            </baidu-map>
            <div class="mark-tool" @click="markToolHandler">
              {{ startMark ? "完成标注" : "标注" }}
              <img class="edit-dialog-map-icon" :src="require('@/assets/image/fp/icon_tool.png')" />
            </div>
          </div> -->

          <el-form-item label="介绍：" prop="introduction">
            <el-input type="textarea" v-model="alameform.introduction" place-holder="请输入介绍"></el-input>
          </el-form-item>
          <el-form-item class="edit-dialog-btns">
            <el-button type="primary" @click="onUploadSubmit"
              class="edit-dialog-btn edit-dialog-btn-confirm">提交</el-button>
            <!-- <el-button class="edit-dialog-btn edit-dialog-btn-cancel">取消</el-button> -->
          </el-form-item>
        </el-form>
      </el-dialog>
      <div class="alame-list-panel">
        <!-- 场地 -->
        <div class="panel-title">
          <div>{{ total ? "介绍" : "" }}</div>
          <div class="fp-primary-btn" @click="uploadInfo()">上传步道信息</div>
          <!-- <el-col :span="20">
            <i></i><h3>介绍</h3>
          </el-col>
          <el-col :span="4" >
                <el-upload
                  class="upload-demo"
                  action="https://jsonplaceholder.typicode.com/posts/"
                  :on-change="handleChange"
                  :file-list="fileList">
                  <el-button size="small" type="primary" style="text-align: center">上传步道文件</el-button>
                </el-upload>
          </el-col> -->
        </div>
        <imgcard-list @itemClick="gotoDetail" :dataList="articleList" />

        <div class="pagination" style="display: none">
          共{{ total }}条
          <el-pagination @current-change="handleCurrentChange" :page-size="9" :pager-count="5" background
            layout="prev, pager, next" :total="total">
          </el-pagination>
        </div>
      </div>
    </section>
    <footer-cmp></footer-cmp>
    <el-dialog :visible.sync="imgPreviewDialogVisible">
      <img width="100%" :src="previewDialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import headerCmp from "../components/common/header.vue";
import menuCmp from "../components/common/navMenu.vue";
import footerCmp from "../components/common/footer.vue";
import ImgcardList from "../components/imgcardList.vue";
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import { BmLocalSearch, BmNavigation } from "vue-baidu-map";
import BmView from "vue-baidu-map/components/map/MapView.vue";
import BmMarker from "vue-baidu-map/components/overlays/Marker.vue";
import BmInfoWindow from "vue-baidu-map/components/overlays/InfoWindow.vue";
import { CodeToText, TextToCode, regionData } from "element-china-area-data";
import alameda from "../api/alameda";
import { Message } from "element-ui";
import upload from "@/utils/upload.js";
import biz from "@/api/biz.js";
import { jsonp } from "vue-jsonp";
import BmPolyline from "vue-baidu-map/components/overlays/Polyline.vue";
import moment from "moment";
let geocoder;
let searchResPage = [1, 1];//检索结果当前页，因为设计为同时发送两个请求所以用两个变量,为节省性能放到外面
let searchResPageLoading = [true, true];//检索结果是否翻页，全部加载后不再翻页
export default {
  components: {
    headerCmp,
    menuCmp,
    footerCmp,
    BaiduMap,
    BmView,
    BmPolyline,
    BmInfoWindow,
    BmMarker,
    BmLocalSearch,
    BmNavigation,
    ImgcardList,
  },
  data() {
    return {
      fileList: [],
      myFunction: null,
      activeName: "",
      isActive: null,
      local: null,
      mapSearchActive: this.$route.query.type || "1", //检索结果展示tab当前  !0 步道or 0场地
      showSearchRes: false, //是否展示搜索结果   移动端隐藏一下
      searchString: this.$route.query.search || "", //检索关键字
      defaultShowWindow: this.$route.query.search || this.$route.query.province, //如果带着搜索条件进入则直接出弹窗
      searchArea: [this.$route.query.province || ""],
      // checkStrictly: this.$route.query.province, //级联选择器是否可选任意一级选项
      // alamedaList: [], //检索的结果列表，默认展示全部
      alamedaList0: [],//场地
      alamedaList1: [],//步道
      alamedaListPoints: [], //检索结果打点
      myMapKey: "X4lQSPOcQT07sFPj45BCrVBNdaTzlbK7", //百度地图服务ak
      center: { lng: 0, lat: 0 }, //展示的大地图中心点
      zoom: 15,
      infoWindow: {}, //详情弹窗的数据
      detailDialog: false, //详情弹窗的

      editCenter: { lng: 0, lat: 0 }, //上传弹窗中的地图中心点
      editPoints: [], //上传弹窗中的地图打点坐标集
      editPoint: null, //上传弹窗中当前打点坐标，默认是用户所在定位，填入地址后检索地址，用户手动打点坐标
      startMark: false, //用户开始打点，鼠标跟随效果
      uploadDialog: false, //上传步道编辑弹窗
      imgPreviewDialogVisible: false, //上传步道编辑弹窗的图片预览
      previewDialogImageUrl: "", //上传步道编辑弹窗的图片预览地址
      regionData: regionData, //上传步道编辑弹窗的省市选择数据
      alameform: {
        //上传步道编辑弹窗的数据
        name: "",
        type: 2,
        address: "",
        points: [],
        region: "",
        regionString: [],
        imgs: [],
        imageUrl: "",
        introduction: "",
      },
      rules: {
        //上传步道编辑弹窗的校验
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 15 个字符",
            trigger: "blur",
          },
        ],
        type: [
          { required: true, message: "请选择上传类型", trigger: "change" },
        ],
        region: [
          { required: true, message: "请选择省市区", trigger: "change" },
        ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "change" },
        ],
        // imgs: [
        //   { required: true, message: "请上传封面图片", trigger: "change" },
        // ],
        // points: [
        //   { required: true, message: "请在地图上完成标注", trigger: "change" },
        // ],
        // introduction: [
        //   { required: true, message: "请输入介绍", trigger: "blur" },
        // ],
      },
      detailList: [
        [
          {
            //详情弹窗展示的内容项，步道和场地不同
            id: "name",
            title: "场地名称",
          },
          {
            id: "constructedBy",
            title: "施工企业",
          },
          {
            id: "surfaceSupplier",
            title: "材料企业",
          },
          {
            id: "certsn",
            title: "证书编号",
          },
          {
            id: "issuedate",
            title: "发证日期",
          },
          {
            id: "validdate",
            title: "证书有效期",
          },
        ],
        [
          // {
          //   id: "name",
          //   title: "步道名称",
          // },
          // {
          //   id: "rank",
          //   title: "星级",
          // },
          // {
          //   id: "address",
          //   title: "位置",
          // },
          {
            id: "length",
            title: "步道单程距离",
            unit: '公里'
          },
          {
            id: "minwidth",
            title: "最小宽度",
            unit: '米'
          },
          {
            id: "highlight",
            title: "步道特色",
          },
          {
            id: "surface",
            title: "面层材料",
          },
          {
            id: "surfaceSupplier",
            title: "面层材料单位",
          },
          {
            id: "ownedBy",
            title: "步道的建设单位",
          },
          {
            id: "operatedBy",
            title: "运营单位",
          },
          {
            id: "constructedBy",
            title: "施工单位",
          },
          {
            id: "introduction",
            title: "步道介绍",
          },
          {
            id: "capability",
            title: "单次赛事活动承载人数（参考）",
          },
          {
            id: "athletics",
            title: "适合举行的比赛",
          },
          {
            id: "event",
            title: "举办过的大型赛事",
          },
          {
            id: "comment",
            title: "步道评价标语",
          },
          {
            id: "certsn",
            title: "证书编号",
          },
          {
            id: "issuedate",
            title: "发证日期",
          },
          {
            id: "validdate",
            title: "证书有效期",
          },
        ],
      ],
      stringOver: [],
      articleList: [], //下面文章列表
      pageNum: 1,
      total: 0,
    };
  },

  methods: {
    moment,
    uploadInfo() {
      if (!localStorage.getItem("token")) {
        this.$refs.menuEle.showLogin();
        return;
      } else {
        this.uploadDialog = true;
      }
    },
    /**
     *  tab点击响应
     **/
    handleTabClick() {
      const alamedaListPoints = this.mapSearchActive == 0 ? this.alamedaList0 : this.alamedaList1;
      this.alamedaListPoints = alamedaListPoints;
      if (alamedaListPoints.length) {
        this.center = alamedaListPoints[0].point;
        this.infoWindowOpen(alamedaListPoints[0]);
      } else {
        this.infoWindow && this.infoWindowClose(this.infoWindow);
      }
    },
    /****
     * 搜索框 地址选择响应
     */
    handleSearchAreaChange(val) {
      this.searchArea = val.map((i) => CodeToText[i]); //处理成文字
      this.searchArea = val;
      this.$refs.searchCascader.dropDownVisible = false;
      this.getAlamedaList();
      this.showSearchRes = true;
    },
    getInfoWndText(item) {
      if (item.title === "步道单程距离") {
        return ((this.infoWindow.length + 0) / 1000).toFixed(2);
      }
      if (item.title === "最小宽度") {
        return (this.infoWindow.minwidth + 0).toFixed(2);
      }
      if (item.title !== "证书有效期") {
        return this.infoWindow[item.id];
      } else {
        var issuedate = this.infoWindow["issuedate"];
        if (issuedate) {
          //五年自动过期
          var date = new Date(issuedate);
          var today = new Date();
          date.setFullYear(date.getFullYear() + 5);
          if (today > date) {
            return "已过期";
          } else {
            return this.infoWindow[item.id];
          }
        } else {
          return null;
        }


      }
    },
    getBaiduMapPoint(addr, obj) {
      jsonp(`http://api.map.baidu.com/geocoder/v2/`, {
        output: "json",
        ak: "X4lQSPOcQT07sFPj45BCrVBNdaTzlbK7",
        address: addr,
      }).then((res) => {
        constlocation = res.result.location;
        console.log("getBaiduMapPoint", res.result);
        if (location) {
          obj.lng = location.lng;
          obj.lat = location.lat;
        }
      });
    },
    //文件上传
    // handleChange(){},
    /**
     *  大地图初始化
     **/
    mapHandler({ map }) {
      this.center.lng = 116.404;
      this.center.lat = 39.915;
      this.zoom = 16;
      this.map = map;
      this.getAlamedaList();
      geocoder = new BMap.Geocoder();
    },

    getSiteCategoryText(item) {
      var chn = ["I类场地", "II类场地", "III类场地"];
      if (item.rank > 0 && item.rank < 4) {
        return chn[item.rank - 1];
      } else {
        return item.certsn ? item.certsn.match(/-A(\S+?)-/)[1] + "类场地" : "";
      }
    },
    closeDialog() {
      this.editPoints = [];
      (this.alameform = {
        //上传步道编辑弹窗的数据
        name: "",
        type: 2,
        address: "",
        points: [],
        region: "",
        regionString: [],
        imgs: [],
        imageUrl: "",
        introduction: "",
      }),
        (this.uploadDialog = false);
    },

    // 查询结果滚动监听
    handleResultScroll(type) {
      if (searchResPageLoading[type]) {
        searchResPage[type]++;
        this.getAlamedaList(type);
      }
      // console.log('this.searchResPage:', searchResPage[i])
    },
    /**
     *  检索场地步道列表
     **/
    getAlamedaList(type) {
      const _this = this;
      const searchArea = this.searchArea;
      if (type === undefined) {
        //非翻页时做初始化
        searchResPage = [1, 1];
        searchResPageLoading = [true, true];
        document.getElementsByClassName('scrollview')[0].scrollTop = 0;
        document.getElementsByClassName('scrollview')[1].scrollTop = 0;
      }

      // type有值则为翻页
      if (type === undefined || type == 0) {
        // 查询场地
        alameda
          .list({
            kw: this.searchString,
            province: searchArea[0],
            city: searchArea[1],
            district: searchArea[2],
            show: 1,
            pageSize: 20,
            pageIndex: searchResPage[0],
            type: 0,
          }).then((res) => {
            if (res.data && res.data.list.length) {
              // const center = this.center;
              let data = res.data.list.map((i, index) => {
                if (
                  i.points == null ||
                  i.points == undefined ||
                  i.points.length <= 0
                ) {
                  var address = "";
                  address += i.province ? i.province : "";
                  address += i.city ? i.city : "";
                  address += i.district ? i.district : "";
                  address += i.address ? i.address : "";
                  if (address == i.province) {
                    address = i.name ? i.name : "";
                    //_this.getBaiduMapPoint(address,i);
                    // _this.local = new BMap.LocalSearch(_this.map, {
                    //   onSearchComplete: (w) => {
                    //     // console.log('onSearchComplete',w, w.getPoi(0).point);
                    //     // if (_this.local.getResults().getPoi(0)) {
                    //     //   let point = _this.local.getResults().getPoi(0).point;
                    //     //   i.point = point;
                    //     //   i.points = [point];
                    //     // }
                    //     const pt = w.getPoi(0) && w.getPoi(0).point;
                    //     if (pt) {
                    //       i.point = pt;
                    //       i.points = [pt];
                    //       if (type === undefined && index == 0 && _this.mapSearchActive == 0) {
                    //         _this.center = pt;
                    //         _this.infoWindowOpen(i);
                    //       }
                    //     }
                    //     // if(w.Kr){
                    //     //   i.point = w.Kr[0].point ;
                    //     // i.points = [w.Kr[0].point];
                    //     // }else if(w.Xr){
                    //     //   i.point = w.Xr[0].point ;
                    //     //   i.points = [w.Xr[0].point];
                    //     // }else if(w.Yr){
                    //     //   i.point = w.Yr[0].point ;
                    //     //   i.points = [w.Yr[0].point];
                    //     // }

                    //   },
                    // });
                    // _this.local.search(address);
                  } else {
                    // geocoder.getPoint(address, (point) => {
                    //   i.point = point;
                    //   i.points = [point];
                    //   if (type === undefined && index == 0 && _this.mapSearchActive == 0) {
                    //     _this.center = point;
                    //     _this.infoWindowOpen(i);
                    //   }
                    //   //如果带着检索条件进来 则默认展示第一个弹窗内容，并把默认展示弹窗标识位置为false，因为这里用到了异步获取坐标点，所以这段代码写了4次
                    //   if (_this.defaultShowWindow && _this.mapSearchActive == 0) {
                    //     _this.showMapWindow(i);
                    //     _this.defaultShowWindow = false;
                    //   }
                    // });
                  }
                  // var local = new BMap.LocalSearch(this.map, {
                  //   renderOptions: { map: null },
                  // });
                  // local.search(i.province + i.city + i.district + i.address);
                } else {
                  // i.point = i.points[0];
                  // if (_this.defaultShowWindow && _this.mapSearchActive == 0) {
                  //   _this.showMapWindow(i);
                  //   _this.defaultShowWindow = false;
                  // }
                }
                _this.infoWindowOpen(i);
                return i;
              });
              if (type === undefined) {
                _this.alamedaList0 = data;
                _this.mapSearchActive == 0 && this.handleTabClick();
              } else {
                _this.alamedaList0.push(...data);
              }
              searchResPageLoading[0] = !res.data.isLastPage;
            } else {
              if (type === undefined) {
                _this.alamedaList0 = [];
                _this.infoWindow && _this.infoWindowClose(this.infoWindow);
                const area = _this.searchArea.join("");
                // if (area.length) {
                //   geocoder.getPoint(area, (point) => {
                //     _this.center = point;
                //   });
                // }
              }
            }
          });
      }
      if (type === undefined || type == 1) {
        //查询步道
        alameda
          .list({
            kw: this.searchString,
            province: searchArea[0],
            city: searchArea[1],
            district: searchArea[2],
            show: 1,
            pageSize: 20,
            pageIndex: searchResPage[1],
            type: 4,
          })
          .then((res) => {
            if (res.data && res.data.list.length) {
              let data = res.data.list.map((i, index) => {
                if (
                  i.points == null ||
                  i.points == undefined ||
                  i.points.length <= 0
                ) {
                  var address = "";
                  address += i.province ? i.province : "";
                  address += i.city ? i.city : "";
                  address += i.district ? i.district : "";
                  address += i.address ? i.address : "";
                  if (address == i.province) {
                    address = i.name ? i.name : "";
                    //_this.getBaiduMapPoint(address,i);
                    // _this.local = new BMap.LocalSearch(_this.map, {
                    //   onSearchComplete: (w) => {
                    //     // console.log('onSearchComplete',w, i);
                    //     const pt = w.getPoi(0) && w.getPoi(0).point;
                    //     if (pt) {
                    //       i.point = pt;
                    //       i.points = [pt];
                    //       if (type === undefined && index == 0 && _this.mapSearchActive != 0) {
                    //         _this.center = pt;
                    //         _this.infoWindowOpen(i);
                    //       }
                    //     }
                    //     // if(w.Kr){
                    //     //   i.point = w.Kr[0].point ;
                    //     // i.points = [w.Kr[0].point];
                    //     // }else if(w.Xr){
                    //     //   i.point = w.Xr[0].point ;
                    //     //   i.points = [w.Xr[0].point];
                    //     // }else if(w.Yr){
                    //     //   i.point = w.Yr[0].point ;
                    //     //   i.points = [w.Yr[0].point];
                    //     // }

                    //   },
                    // });
                    // _this.local.search(address);
                  } else {
                    // geocoder.getPoint(address, (point) => {
                    //   i.point = point;
                    //   i.points = [point];
                    //   if (type === undefined && index == 0 && _this.mapSearchActive != 0) {
                    //     _this.center = point;
                    //     _this.infoWindowOpen(i);
                    //   }
                    //   //如果带着检索条件进来 则默认展示第一个弹窗内容，并把默认展示弹窗标识位置为false，因为这里用到了异步获取坐标点，所以这段代码写了4次
                    //   if (_this.defaultShowWindow && _this.mapSearchActive != 0) {
                    //     _this.showMapWindow(i);
                    //     _this.defaultShowWindow = false;
                    //   }
                    // });
                  }
                } else {
                  // i.point = i.points[0];
                  // if (_this.defaultShowWindow && _this.mapSearchActive != 0) {
                  //   _this.showMapWindow(i);
                  //   _this.defaultShowWindow = false;
                  // }
                }

                _this.infoWindowOpen(i);
                return i;
              });
              if (type === undefined) {
                _this.alamedaList1 = data;
                _this.mapSearchActive != 0 && this.handleTabClick();
              } else {
                _this.alamedaList1.push(...data);
              }
              searchResPageLoading[1] = !res.data.isLastPage;
            } else {
              if (type === undefined) {
                _this.alamedaList1 = [];
                _this.infoWindow && _this.infoWindowClose(this.infoWindow);
                const area = _this.searchArea.join("");
                // if (area.length) {
                //   geocoder.getPoint(area, (point) => {
                //     _this.center = point;
                //   });
                // }
              }
            }
          });
      }
    },
    /**
     *  show大地图上弹窗
     **/
    showMapWindow(marker) {
      // console.log("showMapWindow", marker);

      if (marker) {
        this.infoWindow && this.infoWindowClose(this.infoWindow);
        this.showSearchRes = false;
        this.center = marker.point;
        //this.map.setCenter(marker.points[0]);
        this.infoWindowOpen(marker);
      }
    },
    /**
     *  关闭大地图上弹窗
     **/
    infoWindowClose(marker) {
      marker.showFlag = false;
    },
    /**
     *  点击地图上某点，或点击结果列表某条打开大地图上弹窗
     **/
    infoWindowOpen(marker) {
      if (marker) {
        this.infoWindow = marker;
        this.infoWindow.issuedate = this.infoWindow.issuedate
          ? this.infoWindow.issuedate.split("T")[0]
          : "";
        this.infoWindow.validdate = this.infoWindow.validdate
          ? this.infoWindow.validdate.split("T")[0]
          : "";
        marker.showFlag = true;
        // const mapViewWidth = this.$refs["bmViewRef"].$el.clientWidth;
        // if (mapViewWidth < 960) {
        //   //移动端要把弹窗放中间   pc需要计算弹窗当前相对地图容器位置
        //   this.map.panBy(-15 * (mapViewWidth / 375), 30);
        // }
      }
    },

    /**
     *  点击大地图上查看更多，展示详情信息弹窗
     **/
    showDetailDialog() {
      this.detailDialog = true;
    },
    isIOS() {
      let u = navigator.userAgent;
      // let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   //判断是否是 android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      return isIOS;
    },

    isWexinandIos() {
      let ua = "" + window.navigator.userAgent.toLowerCase();
      // 通过正则表达式匹配ua中是否含有MicroMessenger字符串且是IOS系统
      let isWeixin = /MicroMessenger/i.test(ua); // 是在微信浏览器
      let isIos = /\(i[^;]+;( U;)? CPU.+Mac OS X/i.test(ua); // 是IOS系统
      return isWeixin && isIos;
    },
    /**
     *  导航
     **/
    wakeBaidu(item) {
      var geolocation = new BMap.Geolocation();
      const _this = this;
      geolocation.getCurrentPosition(function (result) {
        if (this.getStatus() == BMAP_STATUS_SUCCESS) {
          var latCurrent = result.point.lat; //获取到的纬度
          var lngCurrent = result.point.lng; //获取到的经度
          const p = item.points[0] ? item.points[0] : item.point;
          let urlObject = {
            lat: p.lat,
            lng: p.lng,
            city: item.city,
            address: item.address,
          };
          if (latCurrent && lngCurrent) {
            var scheme = "";
            var queryStr = `?origin=name:我的位置|latlng:${latCurrent},${lngCurrent}&destination=name:${urlObject.address}|latlng:${urlObject.lat},${urlObject.lng}&region=${urlObject.city}&coord_type=bd09ll&mode=driving`;

            if (_this.isIOS()) {
              // ios 端
              scheme = "baidumap://map/direction" + queryStr;
            } else {
              // android 端
              scheme = "bdapp://map/direction" + queryStr;
            }

            // 主要实现代码
            window.location.href = scheme;

            var startTime = Date.now();
            var count = 0;
            var endTime = 0;

            var t = setInterval(function () {
              count += 1;
              endTime = Date.now() - startTime;
              if (endTime > 800) {
                clearInterval(t);
              }
              if (count < 30) return;
              if (!(document.hidden || document.webkitHidden)) {
                window.location.href =
                  "http://api.map.baidu.com/direction" +
                  queryStr +
                  "&output=html";
              }
            }, 20);

            window.onblur = function () {
              clearInterval(t);
            };
          } else {
            alert("获取不到定位，请检查手机定位设置");
          }
        } else {
          const p = item.points[0] ? item.points[0] : item.point;
          let urlObject = {
            lat: p.lat,
            lng: p.lng,
            city: item.city,
            address: item.address,
          };
          var queryStr = `destination=name:${urlObject.address}|latlng:${urlObject.lat},${urlObject.lng}&region=${urlObject.city}&coord_type=bd09ll&mode=driving`;

          if (_this.isIOS()) {
            // ios 端
            scheme = "baidumap://map/direction" + queryStr;
          } else {
            // android 端
            scheme = "bdapp://map/direction" + queryStr;
          }

          // 主要实现代码
          window.location.href = scheme;

          var startTime = Date.now();
          var count = 0;
          var endTime = 0;

          var t = setInterval(function () {
            count += 1;
            endTime = Date.now() - startTime;
            if (endTime > 800) {
              clearInterval(t);
            }
            if (count < 30) return;
            if (!(document.hidden || document.webkitHidden)) {
              window.location.href =
                "http://api.map.baidu.com/direction" +
                queryStr +
                "&output=html";
            }
          }, 20);

          window.onblur = function () {
            clearInterval(t);
          };
        }
      });
    },
    /**
     *  上传步道弹窗--图片选择成功回调
     **/
    handleImgSuccess(res, file) {
      //this.alameform.imageUrl = URL.createObjectURL(file.raw);
      this.alameform.imgs.push(res.url);
    },

    /**
     * @description [fnUploadRequest 覆盖默认的上传行为，实现自定义上传]
     * @param    {object}    [上传选项]
     * @return   {null}   [没有返回]
     */
    fnUploadRequest(param) {
      upload.ossUploadFile(param);
    },
    /**
     *  上传步道弹窗--图片上传-上传前校验格式和大小
     **/
    beforeImgUpload(file) {
      const isAccept = ["image/jpeg", "image/png"].includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 30;

      if (!isAccept) {
        this.$message.error("支持png/jpg/pdf文件!");
      }
      if (!isLt2M) {
        this.$message.error("上传小于30MB的文件!");
      }
      return isAccept && isLt2M;
    },
    /**
     *  上传步道弹窗--图片上传-删除上传的图片
     **/
    handleRemove(file, fileList) {
      this.alameform.imgs.splice(fileList.indexOf(file));
    },
    /**
     *  上传步道弹窗--图片上传-上传后预览
     **/
    handlePictureCardPreview(file) {
      this.previewDialogImageUrl = file.url;
      this.imgPreviewDialogVisible = true;
    },
    /**
     *  上传步道弹窗--省市区选择，处理成地址供地图设置标记点
     **/
    handleRegionChange(val) {
      let region = val.map((i) => CodeToText[i]);
      this.alameform.region = val;
      this.alameform.regionString = region;
    },
    /**
     *  上传步道弹窗--地图初始化
     **/
    editMapReady({ BMap, map }) {
      const _this = this;
      this.editMap = map;
      this.BMap = BMap;
      // 获取自动定位方法
      var geolocation = new BMap.Geolocation();
      // 获取逆解析方法实例
      this.myGeo = new BMap.Geocoder();
      // 获取自动定位获取的坐标信息
      geolocation.getCurrentPosition(
        function (r) {
          _this.editCenter = {
            lng: r.point.lng,
            lat: r.point.lat,
          };
          _this.editPoint = {
            lng: r.point.lng,
            lat: r.point.lat,
          };
        },
        { enableHighAccuracy: true }
      );
    },
    /**
     *  上传步道弹窗--地图-地图上戳点之后的响应，如果没有填地址则自动填地址
     **/
    editSelectPoint({ type, target, point }) {
      if (!this.startMark) {
        return false;
      }
      // this.markToolClose();
      // this.editPoint = point;
      this.editPoints.push(point);
      if (this.editPoints.length == 1) {
        //如果是第一个点  则把第一个点的位置回填到地址
        const _this = this;
        if (!this.alameform.region || !this.alameform.address) {
          // 根据坐标逆解析获取地址详细描述
          this.myGeo.getLocation(point, function (result) {
            if (result) {
              // let city = i=>['北京市', '天津市', '上海市', '重庆市', '天津市'].includes(i) ? '市辖区' : i;
              let region =
                TextToCode[result.addressComponents.province][
                  result.addressComponents.city
                ][result.addressComponents.district].code || "";
              let regionString = [
                result.addressComponents.province,
                result.addressComponents.city,
                result.addressComponents.district,
              ];

              region && (_this.alameform.region = region);

              //详细地址的信息回显
              _this.alameform.regionString = regionString;
              _this.alameform.address =
                result.surroundingPois.length > 0
                  ? result.surroundingPois[0].address +
                  result.surroundingPois[0].title
                  : result.address;
            }
          });
        }
      }
    },

    /**
     *  上传步道弹窗--地图-开始标注，用户点击标注工具
     **/
    markToolHandler() {
      if (!this.startMark) {
        this.startMark = true;
        const map = this.editMap;
        const BMap = this.BMap;
        this.editPoints = [];
        const followMarker = new BMap.Marker(map.getCenter(), {
          offset: new BMap.Size(0, 0),
        });
        map.addOverlay(followMarker);
        //followMarker.setZIndex(10000);
        map.setDefaultCursor(
          "url(http://api.map.baidu.com/library/MarkerTool/1.2/src/images/transparent.cur), default"
        );
        followMarker.hide();
        this.followMarker = followMarker;
        //绑定mousemove事件
        this._mouseMoveHandler = function (evt) {
          var pt = evt.point;
          followMarker.setPosition(pt);
          followMarker.show();
        };
        map.addEventListener("mousemove", this._mouseMoveHandler);
      } else {
        this.markToolClose();
      }
    },
    /**
     *   上传步道弹窗--地图-路径
     **/
    updatePolylinePath(e) {
      this.editPoints = e.target.getPath();
    },
    /**
     *   上传步道弹窗--地图-清空路径
     **/
    clearPoints() {
      this.editPoints = [];
    },
    /**
     *  上传步道弹窗--地图-结束标注，用户打点后就结束标注
     **/
    markToolClose() {
      //取消绑定事件
      this.startMark = false;
      this.alameform.points = this.editPoints;
      this.editMap.removeEventListener("mousemove", this._mouseMoveHandler);
      if (this.editPoints != null && this.editPoints.length > 0) {
        this.editCenter = JSON.parse(JSON.stringify(this.editPoints[0]));
      }
      // this.followMarker.hide();//隐藏跟随marker
    },

    /**
     *  上传步道弹窗--提交表单数据
     **/
    onUploadSubmit() {
      const _this = this;
      this.$refs["alameformRef"].validate((valid) => {
        if (valid) {
          let params = this.alameform;

          params.province = params.regionString[0];
          params.city = params.regionString[1];
          params.district = params.regionString[2];
          params.points = _this.editPoints;

          alameda.add(params).then(
            (res) => {
              if (res.errCode == 0) {
                Message.success("提交成功!");
                _this.alameform = {
                  //上传步道编辑弹窗的数据
                  name: "",
                  type: 2,
                  address: "",
                  points: [],
                  region: "",
                  regionString: [],
                  imgs: [],
                  imageUrl: "",
                  introduction: "",
                };
                _this.editPoints = [];
                _this.uploadDialog = false;
              } else if (err.errCode == 401) {
                _this.$refs.menuEle.showLogin();
              } else {
                Message.error("提交失败，" + res.errMessage);
              }
            },
            (err) => {
              if (err.errCode == 401 || err.response.status == 401) {
                _this.$refs.menuEle.showLogin();
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    /**
     * reset
     ***/
    resetForm() {
      this.$refs.imgUploaderRef.clearFiles();
    },
    itemClick(item) {
      this.infoWindow = item;
      this.showDetailDialog();
    },
    /****下面都是图文列表 */

    handleCurrentChange(v) {
      this.pageNum = v;
      this.getArticleList();
    },
    getArticleList() {
      biz
        .fetch({
          name: "步道审定",
        })
        .then((res) => {
          this.articleList = res.data.relatedCases;
        });
    },
    gotoDetail(item) {
      this.$router.push("/news/newsDetail?id=" + item.id);
    },
  },
  mounted() {
    var self = this;
    this.getAlamedaList();
    this.getArticleList();
    if (this.isWexinandIos()) {
      document.body.addEventListener("focusin", () => {
        // 软键盘弹起事件
        clearTimeout(self.myFunction);
      });
      document.body.addEventListener("focusout", () => {
        // 软键盘关闭事件
        clearTimeout(self.myFunction);
        self.myFunction = setTimeout(function () {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" }); // 重点  =======当键盘收起的时候让页面回到原始位置
        }, 200);
      });
    }
  },
  directives: {
    'searchresult-scroll': {
      bind(el, binding, vnode) {
        // console.log('bind')
        // 判断是否下拉到位
        function handleScroll(e) {
          let isBottom = e.target.clientHeight + e.target.scrollTop >= (e.target.scrollHeight - 150);
          if (isBottom) {
            binding.value(vnode.context.mapSearchActive);
          }
        }

        // 监听滚动
        el.__handleScroll__ = handleScroll;
        el.addEventListener('scroll', handleScroll, true);
      },

      unbind(el, binding, vnode) {
        // 解除事件监听
        el.removeEventListener('scroll', el.__handleScroll__, true);
      },
    },
    'lazy-load': {
      //检索结果翻页时图片影响性能，所以图片改成延迟加载
      bind(el, binding) {
        el.setAttribute('data-src', binding.value)
        // el.setAttribute('src', require('@/assets/image/fp/map-mark-1.png'))
      },
      inserted(el, binding) {
        function observe(el) {
          var io = new IntersectionObserver((entries) => {
            const realSrc = el.dataset.src
            if (entries[0].isIntersecting) {
              if (realSrc) {
                el.src = realSrc
                el.removeAttribute('data-src')
              }
            }
          })
          io.observe(el)
        };
        if (IntersectionObserver) {
          observe(el)
        } else {
          // listenerScroll(el)
          el.setAttribute('src', binding.value)
        }
      },
    }
  },
};
</script>

<style lang="scss" scoped>
.foot-path {
  font-size: 14px;
  font-weight: 400;
  --main-width: 1200px;

  .fp-page {
    min-height: calc(100vh - var(--nav-menu-height) - var(--foot-height));
  }

  .fp-primary-btn {
    background: linear-gradient(144deg, #ef8b89 0%, #da5351 100%);
    border-radius: 30px;
    padding: 8px 25px;
    box-sizing: border-box;
    font-size: 18px;
    color: #ffffff;
    line-height: 25px;
    width: fit-content;
    cursor: pointer;
  }

  .map {
    position: relative;
    background: transparent !important;

    .bmView {
      height: 580px;
      width: 100%;
      position: relative;
    }

    .map-search-panel {
      // position: absolute;
      // left: calc(50% - var(--main-width) / 2);
      // top: 24px;
      // z-index: 1000;
      width: 400px;

      &-h {
        width: 100%;
        display: flex;
      }

      .map-search-cascader {
        width: calc(50% - 26.5px);
      }

      .map-search-res {
        width: 347px;
        background: #ffffff;
        border-radius: 4px;
        box-sizing: border-box;

        /* 设置滚动条的样式 */
        ::-webkit-scrollbar {
          width: 2px;
          display: none;
        }

        .no-data {
          color: #666;
          text-align: center;
          line-height: 80px;
        }

        .alameda-ul {
          box-sizing: border-box;
          height: 100%;
          overflow-y: scroll;
          max-height: 392px;
          padding: 20px 20px 0;
          // position: relative;

          // &::before {
          //   position: absolute;
          //   content: '';
          //   bottom: 0;
          //   height: 30px;
          //   background: linear-gradient(to top, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0));
          //   // background: red;
          //   left: 0;
          //   right: 0;
          // }
        }

        .alameda-li {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 24px;
          cursor: pointer;

          .alameda-li-left {
            flex: 1;
            overflow: hidden;
            cursor: pointer;
            margin-right: 4px;
          }
        }

        .alameda-li-name {
          font-size: 18px;
          font-weight: 500;
          color: #333333;
          line-height: 25px;
          overflow: hidden;
          word-break: keep-all;
          white-space: nowrap;
          text-overflow: ellipsis;
          cursor: pointer;
          max-width: 100%;
          box-sizing: border-box;
        }

        .alameda-li-type {
          color: #999999;
          line-height: 20px;
        }

        .alameda-li-img {
          width: 114px;
          height: 69px;
          border-radius: 4px;
        }
      }

      ::v-deep {
        .map-search-res .el-tabs__header {
          padding: 0 20px;
          margin: 0;
        }

        .el-tabs__item {
          line-height: 22px;
          font-size: 16px;
          padding: 20px 0 15px;
          box-sizing: border-box;
          height: auto;
        }

        .el-tabs__item:hover {
          color: #da5351;
        }

        .map-search-res .el-tabs__item.is-active {
          color: #da5351;
        }

        .map-search-res .el-tabs__active-bar {
          background: #da5351;
          width: 85px !important;
          left: 34.25px;
        }
      }
    }
  }


  ::v-deep {

    .map-search-panel-h .el-cascader .el-input,
    .map-search-panel-h .el-cascader .el-input .el-input__inner {
      height: 100%;
      border-right: 0;
      border-radius: 5px 0 0 5px;
    }

    .map-search-input {
      // width: 50%;
      flex: 1;
      height: 50px;

      .el-input__inner {
        height: 100%;
        padding-right: 100px;
        border-radius: 0 5px 5px 0;
      }

      .el-input__suffix {
        right: 0;
        pointer-events: none;
        right: 0;
        background: #da5351;
        width: 53px;
        color: #fff;
        font-size: 20px;

        .el-icon-search {
          line-height: 50px;
          cursor: pointer;
        }
      }

      .el-input__clear {
        font-size: 20px;
        position: absolute;
        left: -40px;
        color: #000;
      }
    }
  }

  .alameda-li-name-logo {
    width: 27.75px;
    display: inline-block;
    margin-left: 4px;
  }

  .alameda-item-name-wlogo {
    max-width: calc(100% - 35px);
    background: url('../assets/logo.png') no-repeat right center;
    background-size: 27.75px 18px;
    padding-right: 32px;
    width: fit-content;
    box-sizing: border-box;
  }

  .map-info-window-star {
    width: 14px;
    height: 14px;
    vertical-align: middle;
    color: #f2cb52;
  }

  .map-info-window-star.el-icon-star-on {
    font-size: 17px;
    line-height: 14px;
    margin-right: 2px;
  }

  .map-info-window {
    width: 100%;
    // max-height: 280px;
    overflow: auto;

    .map-info-window-body {
      display: flex;
      justify-content: space-between;

      .map-info-window-body-left {
        flex: 1;
        overflow: hidden;
        margin-right: 4px;
      }
    }

    .map-info-window-title {
      font-size: 18px;
      font-weight: 500;
      color: #333333;
      line-height: 25px;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: keep-all;
      white-space: nowrap;
      display: inline-block;
      vertical-align: sub;
      max-width: 100%;
    }

    .map-info-window-tags {
      margin: 5px 0 4px;
      word-break: keep-all;
      white-space: nowrap;
    }

    .map-info-window-tag {
      height: 16px;
      border-radius: 8px;
      border: 1px solid #da5351;
      font-size: 10px;
      color: #da5351;
      line-height: 16px;
      padding: 0 10px;
      width: fit-content;
      margin: 0 5px 0 0;
      display: inline-block;
      vertical-align: middle;
      box-sizing: content-box;
    }

    .map-info-window-tip {
      color: #da5351;
      line-height: 1.5;
      // background: url('../assets/image/home/logo5.png') no-repeat right center;
      // background-size: 27.75px 18px;
      // width: fit-content;
      // padding-right: 32px;
    }

    .map-info-window-tip-un {
      color: #999;
    }

    .alameda-li-type {
      color: #999999;
      line-height: 20px;
    }

    .map-info-window-img {
      width: 114px;
      height: 69px;
      border-radius: 4px;
      display: block;
      background-repeat: no-repeat;
      background-size: cover;
    }

    .map-info-window-address {
      font-size: 14px;
      color: #666;
      line-height: 20px;
    }

    .el-divider {
      background: #f1f1f1;
      margin: 11px 0;
    }

    .map-info-window-footer {
      font-size: 18px;
      color: #da5351;
      line-height: 25px;
      text-align: center;
      cursor: pointer;

      .map-info-window-footer-navigation {
        display: none;
      }
    }
  }

  .a-detail-dialog {
    &-imgs {
      display: flex;
      justify-content: space-between;
      margin-bottom: 6.5px;
    }

    &-title-c {
      color: #da5351;
    }

    &-img {
      width: 180px;
      height: 98px;
      border-radius: 4px;
    }

    &-li {
      font-size: 16px;
      color: #454545;
      line-height: 1.5;
      // margin-bottom: 20px;
      margin-bottom: 10px;
    }

    ::v-deep {
      .el-dialog {
        width: 620px;
      }

      .el-dialog__header {
        font-size: 18px;
        font-weight: 500;
        color: #454545;
        line-height: 25px;
        padding: 21px 24px 16px;
        border-bottom: 1px solid #f1f1f1;

        .el-dialog__headerbtn {
          top: 24px;
          right: 25px;

          .el-dialog__close {
            color: #000;
            font-size: 16px;
          }
        }
      }

      .el-dialog__body {
        padding: 24px;
      }
    }
  }

  .edit-dialog {
    ::v-deep {
      .el-form-item__label {
        width: 106px;
      }

      .el-form-item__content {
        margin-left: 106px;
      }
    }

    &-btn {
      width: 120px;
      height: 40px;
      border-radius: 30px;
      font-size: 18px;
      line-height: 40px;
      padding: 0;
    }

    &-btn:hover {
      color: #333;
      background: #fff;
      border-color: #dcdfe6;
    }

    &-btn-confirm {
      background: linear-gradient(144deg, #ef8b89 0%, #da5351 100%);
      color: #ffffff;
      border: none;
    }

    &-btn-confirm:hover {
      background: linear-gradient(180deg, #da5351 0%, #ef8b89 100%);
      color: #ffffff;
    }

    .edit-dialog-img-uploader-icon {
      width: 23px;
      height: 23px;
      text-align: center;
      position: absolute;
      top: 44.5px;
      left: 44.5px;
    }

    .el-upload--picture-card {
      width: 112px;
      height: 112px;
      display: block;
    }

    .edit-dialog-bm-view {
      width: 100%;
      height: 225px;
      overflow: hidden;
      margin-bottom: 22px;
      border-radius: 4px;
    }

    .edit-dialog-map {
      position: relative;
    }

    .mark-tool {
      position: absolute;
      top: 16px;
      left: 16px;
      width: 109px;
      height: 36px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #e7e7e7;
      color: #454545;
      line-height: 36px;
      text-align: center;
      cursor: pointer;

      .edit-dialog-map-icon {
        width: 14px;
        height: 14px;
        display: inline-block;
        margin-left: 4px;
        vertical-align: text-bottom;
      }
    }

    ::v-deep {

      .el-select,
      .el-cascader {
        width: 100%;
      }

      .edit-dialog-img-uploader .el-upload {
        width: 112px;
        height: 112px;
        border-radius: 4px;
        border: 1px solid #e7e7e7;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        box-sizing: border-box;
        background: #fff;
      }

      .edit-dialog-img-uploader .el-upload__tip {
        font-size: 12px;
        color: #999999;
        line-height: 17px;
      }

      .edit-dialog-img-uploader .el-upload-list--picture-card .el-upload-list__item {
        width: 112px;
        height: 112px;
      }

      .el-upload-list--picture-card .el-progress {
        width: 86px;
        height: 86px;

        .el-progress-circle {
          width: 100% !important;
          height: 100% !important;
        }
      }

      .edit-dialog-btns .el-form-item__content {
        margin: 0 !important;
        text-align: center;
      }
    }
  }

  .alame-list-panel {
    width: var(--main-width);
    max-width: 96%;
    margin: 34px auto 50px;
    box-sizing: border-box;

    .panel-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 40px;

      h3 {
        font-size: 28px;
        color: #222222;
        line-height: 28px;
      }
    }

    // .panel-content{
    //   display: flex;
    //   justify-content: space-between;
    //   flex-wrap: wrap;
    //   align-items: stretch;
    //   i{
    //     width: 31.6%;
    //   }
    //   .list-item{
    //     width: 31.6%;
    //     max-width: 380px;
    //     border-radius: 8px;
    //     overflow: hidden;
    //     margin-bottom: 30px;
    //     display: flex;
    //     flex-direction: column;
    //     cursor: pointer;
    //     &-img{
    //       height: 206px;
    //       width: 100%;
    //       vertical-align: bottom;
    //     }
    //     &-info-date{
    //       color: #B2B2B2;
    //       line-height: 14px;
    //       padding: 16px 20px 0;
    //       border-left: 1px solid #E6E6E6;
    //       border-right: 1px solid #E6E6E6;
    //       display: inline-block;
    //       width: 100%;
    //       box-sizing: border-box;
    //     }
    //     &-info{
    //       background: #FFFFFF;
    //       // opacity: 0.73;
    //       border: 1px solid #E6E6E6;
    //       border-top: 0;
    //       box-sizing: border-box;
    //       padding: 16px 20px;
    //       border-radius: 0 0 8px 8px;
    //       height: 100%;
    //       &-name{
    //         border-top: 2PX dashed #DDDDDD;
    //         font-size: 18px;
    //         color: #222222;
    //         line-height: 18px;
    //         padding: 16px 20px 16px 0;
    //         overflow: hidden;
    //         text-overflow: ellipsis;
    //         word-break: keep-all;
    //         white-space: nowrap;
    //       }
    //       &-desc{
    //         font-size: 16px;
    //         color: #666666;
    //         line-height: 22px;
    //       }
    //       &-desc-over{
    //         overflow : hidden;
    //         text-overflow: ellipsis;
    //         display: -webkit-box;
    //         -webkit-line-clamp: 3;
    //         -webkit-box-orient: vertical;
    //         position: relative;
    //       }
    //       &-desc-over::after{
    //         content: '[...]';
    //         display: inline-block;
    //         color: #FFC40A;
    //         right: 0;
    //         background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0, rgba(255, 255, 255, 1)  10px);
    //         bottom: 0;
    //         position: absolute;
    //         padding-left: 10px;
    //       }
    //     }
    //   }
    // }
  }

  .search-panel {
    width: var(--main-width);
    max-width: 96%;
    padding-top: 24px;
    margin: 0 auto;
    // height: 500px;
    min-height: 480px;
    display: flex;
    // padding-top: 50px;

    // .map-search-panel-h {
    //   position: absolute;
    //   top: 0;
    //   width: 600px;
    // }

    .map-info-window {
      flex: 1;
      width: unset;
      margin: 0 0 0 32px;
      border-radius: 8px;
      // border: 2px solid #da5351;
      padding: 24px 24px 12px;
      // background: rgba(218, 83, 81, .06);
      box-shadow: 0 0 10px 0 rgba(184, 184, 184, 0.6);

      // linear-gradient(144deg, #ef8b89 0%, #da5351 100%)

      .map-info-window-title {
        font-size: 20px;
        line-height: 2;
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .foot-path .map .map-search-panel {
    left: 2%;
  }
}

@media screen and (max-width: 960px) {
  .foot-path {

    // .menu, .footer{display:none;}
    .map {
      margin-top: var(--nav-menu-height);
      box-sizing: border-box;

      .bmView {
        height: 4.8rem;
      }

      .map-search-panel {
        // width: 3.43rem;
        width: 100%;
        left: 0.16rem;
        top: 0.16rem;

        .map-search-input {
          height: 0.43rem;
          font-size: 0.14rem;
          border-radius: 0 5px 5px 0;
          overflow: hidden;
        }

        .map-search-res {
          // width: 2.97rem;
          width: 100%;
          margin-top: 0.04rem;

          .no-data {
            line-height: 0.6rem;
            font-size: 0.12rem;
          }

          .alameda-ul {
            max-height: 3.35rem;
            padding: 0.17rem;
            cursor: pointer;
            position: relative;


            .alameda-li {
              margin-bottom: 0.2rem;
              cursor: pointer;

              .alameda-li-left {
                margin-right: .04rem;
              }
            }
          }

          .alameda-li-name-wrapper {
            margin-bottom: 0.1rem;
          }

          .alameda-li-name {
            font-size: 0.16rem;
            line-height: 0.25rem;
          }

          .alameda-li-type {
            font-size: 0.12rem;
          }

          .alameda-li-img {
            width: 0.9757rem;
            height: 0.5906rem;
          }
        }

        .map-search-res-mo-hide {
          display: none;
        }

        .map-search-cascader {
          width: calc(50% - 0.225rem);
        }

        ::v-deep {
          .map-search-res .el-tabs__header {
            padding: 0 0.2rem;
            margin: 0;
          }

          .el-tabs__item {
            font-size: 0.14rem;
            line-height: 0.2rem;
            padding: 0.17rem 0 0.13rem;
          }

          .map-search-res .el-tabs__active-bar {
            background: #da5351;
            width: 0.72rem !important;
            left: 0.2825rem;
          }

          .map-search-cascader .el-input {
            font-size: 0.14rem;

            .el-icon-circle-close {
              font-size: 0.14rem;
              line-height: 0.4rem;
              margin-right: 0.05rem;
            }
          }

          .map-search-input .el-input__inner {
            padding-right: 0.7rem;
          }

          .map-search-input .el-input__suffix {
            width: 0.45rem;

            .el-icon-search {
              line-height: 0.43rem;
              font-size: 0.14rem;
              width: 100%;
            }

            .el-input__clear {
              font-size: 0.14rem;
              left: -0.25rem;
              line-height: 0.4rem;
            }
          }
        }
      }
    }

    .alameda-li-name-logo {
      width: .2775rem;
      display: inline-block;
      margin-left: .04rem;
    }

    .alameda-item-name-wlogo {
      max-width: calc(100% - .35rem);
      background-size: .2775rem .18rem;
      padding-right: .32rem;
    }

    .map-info-window-star {
      width: 0.14rem;
      height: 0.14rem;
    }

    .map-info-window-star.el-icon-star-off {
      font-size: 0.14rem;
      line-height: 0.14rem;
    }

    .map-info-window-star.el-icon-star-on {
      font-size: 0.17rem;
      line-height: 0.14rem;
      margin-right: 0.02rem;
    }

    .search-panel .map-info-window {
      // max-height: 2.8rem;

      .map-info-window-title {
        font-size: 0.18rem;
        line-height: 0.25rem;
      }

      .map-info-window-body-left {
        margin-right: .04rem;
      }

      .map-info-window-tip {
        font-size: .14rem;
      }

      .map-info-window-tags {
        margin: 0.05rem 0 0.04rem;
      }

      .alameda-li-type {
        font-size: 0.12rem;
      }

      .map-info-window-tag {
        height: 0.16rem;
        border-radius: 0.08rem;
        font-size: 0.1rem;
        line-height: 0.16rem;
        padding: 0 0.1rem;
        margin: 0 0.05rem 0 0;
      }

      .map-info-window-img {
        width: 1.14rem;
        height: 0.69rem;
        border-radius: 0.04rem;
        display: block;
      }

      .map-info-window-address {
        font-size: 0.14rem;
        line-height: 0.2rem;
      }

      .el-divider {
        margin: 0.11rem 0;
      }

      .map-info-window-footer {
        font-size: 0.18rem;
        line-height: 0.25rem;
        position: relative;

        .map-info-window-footer-navigation {
          background: url("../assets/image/fp/navigation.png") no-repeat center top;
          background-size: 0.12rem 0.12rem;
          font-size: 0.1rem;
          color: #666666;
          line-height: 0.14rem;
          padding: 0.16rem 0.1rem 0;
          display: block;
          position: absolute;
          right: 0;
          top: -0.05rem;
          box-sizing: border-box;
        }

        .map-info-window-footer-navigation:after {
          content: "";
          position: absolute;
          width: 2px;
          background: rgba(216, 216, 216, 0.6);
          height: 0.16rem;
          top: 0.06rem;
          left: 0;
        }
      }
    }

    .a-detail-dialog {
      &-imgs {
        margin-bottom: 0.08rem;
      }

      &-img {
        width: 0.9rem;
        height: 0.49rem;
      }

      &-li {
        font-size: 0.12rem;
        margin-bottom: 0.2rem;
      }

      ::v-deep {
        .el-dialog {
          width: 3.2rem;
        }

        .el-dialog__header {
          font-size: 0.16rem;
          line-height: 0.22rem;
          padding: 0.16rem;

          .el-dialog__headerbtn {
            top: 0.2rem;
            right: 0.17rem;

            .el-dialog__close {
              font-size: 0.14rem;
            }
          }
        }

        .el-dialog__body {
          padding: 0.16rem;
        }
      }
    }

    .edit-dialog {
      ::v-deep {
        .el-form-item__label {
          width: 0.86rem;
          padding-right: 0;
        }

        .el-form-item__content {
          margin-left: 0.86rem;
        }

        .edit-dialog-img-uploader {
          .el-upload--picture-card {
            width: 0.6rem;
            height: 0.6rem;
          }

          .el-upload-list--picture-card .el-upload-list__item {
            width: 0.6rem;
            height: 0.6rem;
          }

          .el-upload-list--picture-card .el-progress {
            width: 0.46rem;
            height: 0.46rem;
          }

          .edit-dialog-img-uploader-icon {
            top: 0.185rem;
            left: 0.185rem;
          }
        }
      }
    }

    .alame-list-panel {
      width: 100%;
      max-width: 100%;
      margin: 0.08rem auto 0;
      padding: 0.16rem;

      .panel-title {
        padding-bottom: 0.12rem;
        margin-bottom: 0.15rem;
        border-bottom: 2px solid #f1f1f1;
        font-size: 0.18rem;
        line-height: 0.24rem;

        .fp-primary-btn {
          padding: 0.05rem 0.12rem;
          background: #fff;
          border-radius: 0.15rem;
          border: 1px solid #cc3b3f;
          font-size: 0.14rem;
          color: #cc3b3f;
          line-height: 0.2rem;
        }
      }

      // .panel-content{
      //   .list-item{
      //     width: 100%;
      //     max-width: 100%;
      //     border-radius: 8px;
      //     overflow: hidden;
      //     margin-bottom: 30px;
      //     flex-direction: row-reverse;
      //     border-bottom: 1px solid #F1F1F1;
      //     border-radius: unset;
      //     &-r{
      //       width: 120px;
      //     }
      //     &-img{
      //       width: 120px;
      //       height: 68px;
      //       border-radius: 4px;
      //     }
      //     &-info-date{
      //       font-size: 12px;
      //       text-align: right;
      //       border: none;
      //       padding: 10px 0 10px 0;
      //     }
      //     &-info{
      //       flex: 1;
      //       padding: 0;
      //       border: none;
      //       &-name{
      //         padding: 0;
      //         max-width: 190px;
      //         border: none;
      //         font-size: 14px;
      //         line-height: 22px;
      //         margin-bottom: 4px;
      //       }
      //       &-desc{
      //         font-size: 12px;
      //       }
      //     }
      //   }
      // }
    }

    .search-panel {
      flex-direction: column;
      min-height: unset;

      .map-info-window {
        margin-left: 0;
        margin-top: 20px;
      }
    }
  }
}
</style>
<style lang="scss">
.BMap_cpyCtrl {
  display: none;
}

.anchorBL {
  display: none;
}

.map {
  .BMap_bottom {
    display: none;
  }

  .BMap_pop {

    >div,
    >img:nth-child(10) {
      display: none;
      overflow: unset;
    }

    >div:nth-child(9) {
      display: block;
      overflow: unset;
      width: 355px !important;
      height: auto !important;
    }

    >div:nth-child(8) {
      /*display: block;*/
    }

    .BMap_top {
      display: none;
    }

    .BMap_center {
      background: transparent;
      border: none;
      position: sticky !important;
      height: 100%;
    }
  }

  .BMap_bubble_content {
    background: #ffffff;
    border-radius: 8px;
    border: 2px solid #da5351;
    padding: 24px 24px 12px;
  }

  .BMap_shadow img {
    display: none;
  }
}

@media screen and (max-width: 960px) {
  .map .BMap_pop {
    >div:nth-child(9) {
      width: 3.55rem !important;
    }
  }

  .map .BMap_bubble_content {
    border-radius: 0.08rem;
  }
}
</style>